<template>
  <div class="yssq_process">
    <div
      v-loading="loadingdialog"
      class="process_form"
      style="position: relative"
    >
      <div
        style="
          position: absolute;
          right: 30px;
          top: 30px;
          font-size: 30px;
          color: #606266;
          cursor: pointer;
        "
        @click="back"
      >
        <i class="el-icon-circle-close" />
      </div>

      <div class="jbxx">
        <div class="title">
          <img src="../../assets/img/jbxx.png" alt="" srcset="">
        </div>
        <el-skeleton :loading="loadingTow" animated>
          <template slot="template">
            <div
              style="
                display: flex;
                align-items: center;
                flex-wrap: wrap;
                justify-content: space-between;
              "
            >
              <el-skeleton-item
                v-for="(item, i) in 16"
                :key="i"
                variant="text"
                style="width: 46%; margin-bottom: 20px; height: 40px"
              />

              <el-skeleton-item
                variant="text"
                style="margin-bottom: 20px; height: 40px"
              />
              <el-skeleton-item
                variant="text"
                style="margin-bottom: 20px; height: 40px"
              />
            </div>
          </template>
          <el-form
            ref="jbxxForm"
            :rules="rules"
            :model="formData"
            label-width="110px"
            label-position="right"
          >
            <el-form-item
              label="运输证类型:"
              prop="yszType"
              :rules="validateNullLog"
            >
              <el-select
                v-model="formData.yszType"
                :disabled="type == 'query' || type == 'qxhx' || type == 'xkzhx'"
                placeholder="请选择"
                style="width: 100%"
                @change="yszTypechange"
              >
                <el-option
                  v-for="(item, i) in yszlxList"
                  :key="i"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item
              v-if="formData.yszType != 2"
              label="购买证编号:"
              prop="gmzBh"
              :rules="validateNullLog"
            >
              <div style="width: 348px; display: flex">
                <el-input
                  v-model="formData.gmzBh"
                  :disabled="type == 'query' || type == 'qxhx' || type == 'xkzhx'"
                  style="width: 100%"
                  placeholder="请输入购买证编号"
                  @blur="gmzTableData()"
                >
                  <!-- background-color: gray; -->
                  <i
                    slot="suffix"
                    v-preventReClick
                    style="cursor: pointer; width: 30px; height: 60%"
                    class="el-icon-arrow-down"
                    @click="gmzTableShow"
                  /></el-input>
                <img
                  v-if="
                    formData.yszType == 4 && type != 'query' && type != 'qxhx' && type != 'xkzhx'
                  "
                  slot="append"
                  v-preventReClick
                  style="margin-left: 5px; cursor: pointer"
                  width="39px"
                  height="39px"
                  src="../../assets/img/push.png"
                  @click="addDomain"
                >
              </div>
            </el-form-item>
            <el-form-item
              v-for="(domain, index) in dynamicValidateForm.domains"
              :key="index"
              label="购买证编号"
            >
              <div style="width: 348px; display: flex">
                <el-input
                  v-model="domain.value"
                  :disabled="type == 'query' || type == 'qxhx' || type == 'xkzhx'"
                  placeholder="请输入购买证编号"
                  @change="addGxhtInputChange($event, index)"
                />

                <img
                  v-if="
                    formData.yszType == 4 && type != 'query' && type != 'qxhx' && type != 'xkzhx'
                  "
                  slot="append"
                  style="margin-left: 5px; cursor: pointer"
                  width="39px"
                  height="39px"
                  src="../../assets/img/delete.png"
                  @click.prevent="removeDomain(domain)"
                >
              </div>
            </el-form-item>
            <el-form-item label="包装:" prop="bz" :rules="validateNullLog">
              <el-select
                v-model="formData.bz"
                :disabled="type == 'query' || type == 'qxhx' || type == 'xkzhx'"
                style="width: 100%"
                placeholder="请选择"
                @change="bzchange"
              >
                <el-option
                  v-for="(item, i) in bzList"
                  :key="i"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item
              v-if="formData.yszType != 2"
              label="化学品:"
              prop="hxpMc"
              :rules="validateNullLog"
            >
              <el-input
                v-model="formData.hxpMc"
                disabled
                style="width: 100%"
                placeholder=""
              />
            </el-form-item>
            <el-form-item
              v-else
              label="化学品:"
              prop="hxpMc"
              :rules="validateNullLog"
            >
              <el-cascader
                ref="hxps"
                v-model="formData.hxpBm"
                style="width: 100%"
                placeholder="请选择化学品"
                :disabled="type == 'query' || type == 'qxhx' || type == 'xkzhx'"
                :options="huaxuepinList"
                @change="handleChange"
              />
            </el-form-item>
            <el-form-item
              v-if="formData.yszType != 2"
              :label="
                type == 'query' || type == 'qxhx' || type == 'xkzhx' ? '核准数量:' : '购买数量:'
              "
              prop="gmsl"
              :rules="validateNullLog"
            >
              <div style="width: 348px">
                <el-col :span="15">
                  <el-input
                    v-model="formData.gmsl"
                    disabled
                    placeholder=""
                  />
                </el-col>
                <el-col :span="1">&nbsp;&nbsp;&nbsp;</el-col>
                <el-col :span="8">
                  <el-select
                    v-model="formData.gmsldw"
                    disabled
                    placeholder="单位"
                  >
                    <el-option
                      v-for="(item, i) in yzd_nsjsl_dw"
                      :key="i"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </el-col>
              </div>
            </el-form-item>
            <el-form-item
              v-if="formData.yszType != 3 && formData.yszType != 2"
              label="已申请数量:"
              prop="ysqsl"
              :rules="validateNullLog"
            >
              <div style="width: 348px">
                <el-col :span="15">
                  <el-input
                    v-model="formData.ysqsl"
                    disabled
                    placeholder=""
                  />
                </el-col>
                <el-col :span="1">&nbsp;&nbsp;&nbsp;</el-col>
                <el-col :span="8">
                  <el-select
                    v-model="formData.ysqsldw"
                    disabled
                    placeholder="单位"
                  >
                    <el-option
                      v-for="(item, i) in yzd_nsjsl_dw"
                      :key="i"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </el-col>
              </div>
            </el-form-item>
            <el-form-item
              label="本次运输数量:"
              class="is-required"
              label-width="120px"
            >
              <div style="width: 348px">
                <el-col :span="15">
                  <el-form-item prop="yssl" style="width: 100%">
                    <el-input
                      v-model="formData.yssl"
                      type="number"
                      :disabled="type == 'query' || type == 'qxhx' || type == 'xkzhx'"
                      placeholder=""
                    /></el-form-item>
                </el-col>
                <el-col :span="1">&nbsp;&nbsp;&nbsp;</el-col>
                <el-col :span="8">
                  <el-form-item
                    prop="ysslDw"
                    style="width: 100%"
                    :rules="validateNullLog"
                  >
                    <el-select
                      v-model="formData.ysslDw"
                      :disabled="type == 'query' || type == 'qxhx' || type == 'xkzhx'"
                      placeholder="单位"
                    >
                      <el-option
                        v-for="(item, i) in hxpBmDwList"
                        :key="i"
                        :label="item.label"
                        :value="item.value"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
              </div>
            </el-form-item>
            <el-form-item label="运输方式:" prop="ysfsDataList">
              <el-select
                ref="ysfsxianshi"
                v-model="ysfsDataList"
                :disabled="type == 'query' || type == 'qxhx' || type == 'xkzhx'"
                multiple
                placeholder="请选择"
                style="width: 100%"
                @change="ysfsChange"
              >
                <el-option
                  v-for="(item, i) in ysfsList"
                  :key="i"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item
              label="运输车号/次:"
              prop="hc"
              :rules="{
                required: true,
                validator: (rule, value, callback) => {
                  lengthValidate(rule, value, callback, 'bt', 2500);
                },
                trigger: ['blur', 'change'],
              }"
              style="position: relative"
            >
              <el-input
                v-model="formData.hc"
                :disabled="type == 'query' || type == 'qxhx'|| type == 'xkzhx'"
                placeholder="请输入"
              />
              <div
                style="
                  position: absolute;
                  right: 2px;
                  top: 0;
                  cursor: pointer;
                  font-size: 20px;
                  color: #5b96ee;
                  height: 30;
                  width: 40px;
                  background: white;
                  margin-top: 4px;
                  text-align: center;
                  line-height: 30px;
                "
                :title="formData.hc"
              >
                <i class="el-icon-more" />
              </div>
            </el-form-item>
            <el-form-item
              :label="
                type == 'query' || type == 'qxhx' || type == 'xkzhx' ? '核准次数:' : '有效次数:'
              "
              class="is-required"
            >
              <el-checkbox-group
                v-model="yxcslist"
                :disabled="type == 'query' || type == 'qxhx' || type == 'xkzhx' || yxcsdisabled"
                @change="yxcschange"
              >
                <el-checkbox label="1" name="yxcs">一次有效</el-checkbox>
                <el-checkbox label="2" name="yxcs">多次有效</el-checkbox>
              </el-checkbox-group>
              <!-- <el-radio-group
                v-model="formData.hzcs"
                :disabled="type == 'query' || type == 'qxhx' || type == 'xkzhx' || yxcsdisabled"
              >
                <el-radio label="1">一次有效</el-radio>
                <el-radio label="2">多次有效</el-radio>
              </el-radio-group> -->
            </el-form-item>
            <el-form-item
              v-if="formData.yszType != 2"
              label="购销合同号:"
              prop="gxhth"
              :rules="{
                required: true,
                validator: (rule, value, callback) => {
                  lengthValidate(rule, value, callback, 'bt', 100);
                },
                trigger: ['blur', 'change'],
              }"
            >
              <el-input
                v-model="formData.gxhth"
                :disabled="type == 'query' || type == 'qxhx' || type == 'xkzhx'"
                placeholder="请输入"
                @input="gxhthImage"
              />
            </el-form-item>

            <el-form-item label="起始地:" prop="qsdQh">
              <el-input
                v-if="type == 'query'||type == 'qxhx'||type == 'xkzhx'"
                disabled
                v-text="formData.qsd"
              />
              <el-cascader
                v-else
                ref="refHandleqsd"
                v-model="qsdQh"
                :props="props"
                :disabled="type == 'query' || type == 'qxhx' || type == 'xkzhx'"
                style="width: 100%"
                clearable
                placeholder="请选择"
                filterable
                @change="qhChange($event, 'qsd')"
              />
            </el-form-item>
            <el-form-item label="目的地:" prop="mddQh">
              <el-input
                v-if="type == 'query'||type == 'qxhx' ||type == 'xkzhx'"
                disabled
                v-text="formData.mdd"
              />
              <el-cascader
                v-else
                ref="refHandlemdd"
                v-model="mddQh"
                :disabled="type == 'query' || type == 'qxhx' || type == 'xkzhx'"
                style="width: 100%"
                clearable
                placeholder="请选择"
                :props="props"
                filterable
                @change="qhChange($event, 'mdd')"
              />
            </el-form-item>
            <el-form-item
              label="途径地:"
              prop="tjd"
              :rules="{
                required: true,
                validator: (rule, value, callback) => {
                  lengthValidate(rule, value, callback, 'bt', 255);
                },
                trigger: ['blur', 'change'],
              }"
            >
              <el-input
                v-model="formData.tjd"
                :disabled="type == 'query' || type == 'qxhx' || type == 'xkzhx'"
                style="width: 100%"
                placeholder="请输入"
              />
            </el-form-item>
            <el-form-item
              label="经办人姓名:"
              prop="jbrXm"
              :rules="validateNullLog"
            >
              <el-select
                v-model="formData.jbrXm"
                :disabled="type == 'query' || type == 'qxhx' || type == 'xkzhx' "
                filterable
                clearable
                placeholder="请选择"
                style="width: 100%"
                @change="jbrChange"
              >
                <el-option
                  v-for="(item, i) in jbrList"
                  :key="i"
                  :label="item.xm"
                  :value="item"
                />
              </el-select>
            </el-form-item>
            <el-form-item
              label="经办人证件号:"
              prop="jbrSfz"
              label-width="120px"
              :rules="validateNullLog"
            >
              <el-input
                v-model="formData.jbrSfz"
                disabled
                placeholder="请输入"
                style="width: 100%"
              />
            </el-form-item>
            <el-form-item
              label="经办人手机号:"
              prop="jbrSjhm"
              label-width="120px"
              :rules="validateNullLog"
            >
              <el-input
                v-model="formData.jbrSjhm"
                disabled
                placeholder="请输入"
                style="width: 100%"
              />
            </el-form-item>
            <el-form-item label="行政区划:" style="width: 100%" prop="xzqhList">
              <el-input
                v-if="type == 'query'||type == 'qxhx' ||type == 'xkzhx'"
                v-text="formData.xzqh"
                disabled
              >
              </el-input>
<!--                      v-if="xzqhFlag"-->
              <el-cascader
                v-else
                ref="refHandlexzqh"
                :key="xzqhKey"
                v-model="xzqhList"
                :disabled="type == 'query' || type == 'qxhx' || type == 'xkzhx'"
                style="width: 100%"
                clearable
                placeholder="请选择"
                :props="props"
                filterable
                @change="qhChange($event, 'xzqh')"
              />
              <!-- @visible-change="showfunc($event)" -->
            </el-form-item>
            <p style="color: #5377ff">(提示:请选择起始地所在的行政区划！)</p>
            <el-form-item
              label="备注:"
              style="width: 100%; margin-bottom: 40px"
              prop="beiz"
            >
              <el-input
                v-model="formData.beiz"
                :disabled="type == 'query' || type == 'qxhx' || type == 'xkzhx'"
                placeholder="请输入"
              />
            </el-form-item>
          </el-form>
        </el-skeleton>
      </div>

      <div class="fhdw">
        <div class="title">
          <img src="../../assets/img/fhdw.png" alt="" srcset="">
        </div>
        <el-skeleton :loading="loadingTow" animated>
          <template slot="template">
            <div
              style="
                display: flex;
                align-items: center;
                flex-wrap: wrap;
                justify-content: space-between;
              "
            >
              <el-skeleton-item
                variant="text"
                style="margin-bottom: 20px; width: 46%; height: 40px"
              />
              <el-skeleton-item
                variant="text"
                style="margin-bottom: 20px; width: 46%; height: 40px"
              />
              <el-skeleton-item
                variant="text"
                style="margin-bottom: 20px; width: 30%; height: 40px"
              />
              <el-skeleton-item
                variant="text"
                style="margin-bottom: 20px; width: 30%; height: 40px"
              />
              <el-skeleton-item
                variant="text"
                style="margin-bottom: 20px; width: 30%; height: 40px"
              />
              <el-skeleton-item
                variant="text"
                style="margin-bottom: 20px; width: 100%; height: 40px"
              />
            </div>
          </template>
          <el-form
            ref="fhdwForm"
            :rules="rules"
            :model="formData"
            label-width="130px"
            label-position="right"
          >
            <el-form-item
              label="单位名称:"
              label-width="100px"
              prop="fhdwMc"
              :rules="{
                required: true,
                validator: (rule, value, callback) => {
                  lengthValidate(rule, value, callback, 'bt', 200);
                },
                trigger: ['blur', 'change'],
              }"
            >
              <!-- @focus="fhdwInputDisabled = false"
                @blur="dwmcBlur($event)" -->
              <el-input
                v-model="formData.fhdwMc"
                :disabled="type == 'query' || type == 'qxhx' || type == 'xkzhx'"
                placeholder="请输入或选择单位名称"
              />
              <el-button
                v-preventReClick
                :disabled="type == 'query' || type == 'qxhx' || type == 'xkzhx'"
                class="xuanze"
                @click="danweixuanze(1)"
              >选择</el-button>
            </el-form-item>

            <el-form-item
              label="统一社会信用代码:"
              prop="fhdwTyshxydm"
              label-width="140px"
              :rules="{
                required: true,
                validator: (rule, value, callback) => {
                  lengthValidate(rule, value, callback, 'bt', 100);
                },
                trigger: ['blur', 'change'],
              }"
            >
              <el-input
                v-model="formData.fhdwTyshxydm"
                :disabled="type == 'query' || type == 'qxhx' || type == 'xkzhx'"
                style=""
              />
            </el-form-item>
            <el-form-item
              label="单位座机:"
              label-width="100px"
              prop="fhdwDwzj"
              :rules="{
                required: true,
                validator: (rule, value, callback) => {
                  lengthValidate(rule, value, callback, 'bt', 50);
                },
                trigger: ['blur', 'change'],
              }"
            >
              <el-input
                v-model="formData.fhdwDwzj"
                :disabled="type == 'query' || type == 'qxhx' || type == 'xkzhx'"
              />
            </el-form-item>
            <el-form-item
              label="单位法人/经营者:"
              prop="fhdwDwfr"
              label-width="140px"
              :rules="{
                required: true,
                validator: (rule, value, callback) => {
                  lengthValidate(rule, value, callback, 'bt', 200);
                },
                trigger: ['blur', 'change'],
              }"
            >
              <el-input
                v-model="formData.fhdwDwfr"
                :disabled="type == 'query' || type == 'qxhx' || type == 'xkzhx'"
              />
            </el-form-item>

            <el-form-item
              label="单位地址:"
              style="width: 100%"
              label-width="100px"
              prop="fhdwDwdz"
              :rules="{
                required: true,
                validator: (rule, value, callback) => {
                  lengthValidate(rule, value, callback, 'bt', 600);
                },
                trigger: ['blur', 'change'],
              }"
            >
              <el-input
                v-model="formData.fhdwDwdz"
                :disabled="type == 'query' || type == 'qxhx' || type == 'xkzhx'"
                style="width: 100%"
              />
            </el-form-item>

            <p v-if="formData.yszType == 2 || formData.yszType == 4">
              如果想要将该单位加入往来单位请将信息填写完整！
            </p>
          </el-form>
        </el-skeleton>
      </div>
      <div class="shdw">
        <div class="title">
          <img src="../../assets/img/shdw.png" alt="" srcset="">
        </div>
        <el-skeleton :loading="loadingTow" animated>
          <template slot="template">
            <div
              style="
                display: flex;
                align-items: center;
                flex-wrap: wrap;
                justify-content: space-between;
              "
            >
              <el-skeleton-item
                variant="text"
                style="margin-bottom: 20px; width: 46%; height: 40px"
              />
              <el-skeleton-item
                variant="text"
                style="margin-bottom: 20px; width: 46%; height: 40px"
              />
              <el-skeleton-item
                variant="text"
                style="margin-bottom: 20px; width: 30%; height: 40px"
              />
              <el-skeleton-item
                variant="text"
                style="margin-bottom: 20px; width: 30%; height: 40px"
              />
              <el-skeleton-item
                variant="text"
                style="margin-bottom: 20px; width: 30%; height: 40px"
              />
              <el-skeleton-item
                variant="text"
                style="margin-bottom: 20px; width: 100%; height: 40px"
              />
            </div>
          </template>
          <el-form
            ref="shdwForm"
            :rules="rules"
            :model="formData"
            label-width="130px"
            label-position="right"
          >
            <!-- @focus="shdwInputDisabled = false"
                @blur="dwmcBlur($event)" -->
            <el-form-item
              label="单位名称:"
              label-width="100px"
              prop="shdwMc"
              :rules="{
                required: true,
                validator: (rule, value, callback) => {
                  lengthValidate(rule, value, callback, 'bt', 200);
                },
                trigger: ['blur', 'change'],
              }"
            >
              <el-input
                v-model="formData.shdwMc"
                :disabled="type == 'query' || type == 'qxhx' || type == 'xkzhx'"
                placeholder="请输入或选择单位名称"
              />
              <el-button
                v-preventReClick
                :disabled="type == 'query' || type == 'qxhx' || type == 'xkzhx'"
                class="xuanze"
                @click="danweixuanze(2)"
              >选择</el-button>
            </el-form-item>

            <el-form-item
              label="统一社会信用代码:"
              prop="shdwTyshxydm"
              label-width="140px"
              :rules="{
                required: true,
                validator: (rule, value, callback) => {
                  lengthValidate(rule, value, callback, 'bt', 100);
                },
                trigger: ['blur', 'change'],
              }"
            >
              <el-input
                v-model="formData.shdwTyshxydm"
                :disabled="type == 'query' || type == 'qxhx' || type == 'xkzhx'"
              />
            </el-form-item>
            <el-form-item
              label="单位座机:"
              label-width="100px"
              prop="shdwDwzj"
              :rules="{
                required: true,
                validator: (rule, value, callback) => {
                  lengthValidate(rule, value, callback, 'bt', 50);
                },
                trigger: ['blur', 'change'],
              }"
            >
              <el-input
                v-model="formData.shdwDwzj"
                :disabled="type == 'query' || type == 'qxhx' || type == 'xkzhx'"
              />
            </el-form-item>
            <el-form-item
              label="单位法人/经营者:"
              prop="shdwDwfr"
              label-width="140px"
              :rules="{
                required: true,
                validator: (rule, value, callback) => {
                  lengthValidate(rule, value, callback, 'bt', 200);
                },
                trigger: ['blur', 'change'],
              }"
            >
              <el-input
                v-model="formData.shdwDwfr"
                :disabled="type == 'query' || type == 'qxhx' || type == 'xkzhx'"
              />
            </el-form-item>

            <el-form-item
              prop="shdwDwdz"
              label="单位地址:"
              style="width: 100%"
              label-width="100px"
              :rules="{
                required: true,
                validator: (rule, value, callback) => {
                  lengthValidate(rule, value, callback, 'bt', 600);
                },
                trigger: ['blur', 'change'],
              }"
            >
              <el-input
                v-model="formData.shdwDwdz"
                :disabled="type == 'query' || type == 'qxhx' || type == 'xkzhx'"
                style="width: 100%"
              />
            </el-form-item>
            <p v-if="formData.yszType == 4">
              如果想要将该单位加入往来单位请将信息填写完整！
            </p>
          </el-form>
        </el-skeleton>
      </div>
      <div class="ysdw">
        <div class="title">
          <img src="../../assets/img/ysdw.png" alt="" srcset="">
        </div>
        <el-skeleton :loading="loadingTow" animated>
          <template slot="template">
            <div
              style="
                display: flex;
                align-items: center;
                flex-wrap: wrap;
                justify-content: space-between;
              "
            >
              <el-skeleton-item
                variant="text"
                style="margin-bottom: 20px; width: 46%; height: 40px"
              />
              <el-skeleton-item
                variant="text"
                style="margin-bottom: 20px; width: 46%; height: 40px"
              />
              <el-skeleton-item
                variant="text"
                style="margin-bottom: 20px; width: 30%; height: 40px"
              />
              <el-skeleton-item
                variant="text"
                style="margin-bottom: 20px; width: 30%; height: 40px"
              />
              <el-skeleton-item
                variant="text"
                style="margin-bottom: 20px; width: 30%; height: 40px"
              />
              <el-skeleton-item
                variant="text"
                style="margin-bottom: 20px; width: 100%; height: 40px"
              />
            </div>
          </template>
          <el-form
            ref="ysdwForm"
            :rules="rules"
            :model="formData"
            label-width="130px"
            label-position="right"
          >
            <!-- @focus="ysdwInputDisabled = false"
                @blur="dwmcBlur($event)" -->
            <el-form-item
              label="单位名称:"
              label-width="100px"
              prop="ysdwMc"
              :rules="{
                required: true,
                validator: (rule, value, callback) => {
                  lengthValidate(rule, value, callback, 'bt', 200);
                },
                trigger: ['blur', 'change'],
              }"
            >
              <el-input
                v-model="formData.ysdwMc"
                :disabled="type == 'query' || type == 'qxhx' || type == 'xkzhx'"
                placeholder="请输入或选择单位名称"
              />
              <el-button
                v-preventReClick
                :disabled="type == 'query' || type == 'qxhx' || type == 'xkzhx'"
                class="xuanze"
                @click="danweixuanze(3)"
              >选择</el-button>
            </el-form-item>

            <el-form-item
              label="统一社会信用代码:"
              prop="ysdwTyshxydm"
              label-width="140px"
              :rules="{
                required: true,
                validator: (rule, value, callback) => {
                  lengthValidate(rule, value, callback, 'bt', 100);
                },
                trigger: ['blur', 'change'],
              }"
            >
              <el-input
                v-model="formData.ysdwTyshxydm"
                :disabled="type == 'query' || type == 'qxhx' || type == 'xkzhx'"
              />
            </el-form-item>
            <el-form-item
              label="单位座机:"
              label-width="100px"
              prop="ysdwDwzj"
              :rules="{
                required: true,
                validator: (rule, value, callback) => {
                  lengthValidate(rule, value, callback, 'bt', 50);
                },
                trigger: ['blur', 'change'],
              }"
            >
              <el-input
                v-model="formData.ysdwDwzj"
                :disabled="type == 'query' || type == 'qxhx' || type == 'xkzhx'"
              />
            </el-form-item>
            <el-form-item
              label="单位法人/经营者:"
              prop="ysdwDwfr"
              label-width="140px"
              :rules="{
                required: true,
                validator: (rule, value, callback) => {
                  lengthValidate(rule, value, callback, 'bt', 200);
                },
                trigger: ['blur', 'change'],
              }"
            >
              <el-input
                v-model="formData.ysdwDwfr"
                :disabled="type == 'query' || type == 'qxhx' || type == 'xkzhx'"
              />
            </el-form-item>

            <el-form-item
              prop="ysdwDwdz"
              label="单位地址:"
              style="width: 100%"
              label-width="100px"
              :rules="{
                required: true,
                validator: (rule, value, callback) => {
                  lengthValidate(rule, value, callback, 'bt', 600);
                },
                trigger: ['blur', 'change'],
              }"
            >
              <el-input
                v-model="formData.ysdwDwdz"
                :disabled="type == 'query' || type == 'qxhx' || type == 'xkzhx'"
                style="width: 100%"
              />
            </el-form-item>
            <p>如果想要将该单位加入往来单位请将信息填写完整！</p>
          </el-form>
        </el-skeleton>
      </div>
      <div class="xgzl">
        <div class="title" style="margin-bottom: 28px">
          <img src="../../assets/img/xgzl.png" alt="" srcset="">
        </div>
        <div class="tishi">
          <img src="@/assets/img/tishi.png" alt="" srcset="">
          <p>
            提示:&nbsp;“营业执照复印件”或“其他组织的登记证书”或“货主身份证明”三选一即可;支持上传png、jpg、bmp格式,500KB以内证明照片。
          </p>
        </div>
        <el-skeleton :loading="loadingTow" animated>
          <template slot="template">
            <div>
              <div v-for="(item, i) in 6" :key="i">
                <el-skeleton-item
                  variant="image"
                  style="width: 202px; height: 138px"
                />
                <el-skeleton-item variant="text" />
              </div>
              <div style="width: 202px; visibility: hidden" />
              <div style="width: 202px; visibility: hidden" />
            </div>
          </template>

          <div class="xgzlsc">
            <div v-for="(item, i) in xgzlList" :key="i">
              <el-image
                v-preventReClick
                style="width: 202px; height: 138px; cursor: pointer"
                :src="item.img"
                @click="imageClick(item.pupopType, item.zjlx)"
              />

              <p v-html="item.xianshi" />
            </div>
            <div style="width: 202px; visibility: hidden" />
            <div style="width: 202px; visibility: hidden" />
          </div>
        </el-skeleton>
        <!-- <div style="display: flex; flex-wrap: wrap">
            <div style="width: 49%; margin-right: 2%">
              <span style="font-weight: bold">修改前内容：</span>仓库剩余量900吨
            </div>
            <div style="width: 49%">
              <span style="font-weight: bold">修改后内容：</span>仓库剩余量450吨
            </div>
            <div style="width: 100%; margin-top: 20px; margin-bottom: 20px">
              <span style="font-weight: bold">修改时间：</span>2020-01-01
            </div>
          </div> -->

        <!-- <div class="buttonList" v-if="type == 'query'">
          <el-button class="tjsq" v-preventReClick @click="ZSsave(4)"
            >打印</el-button
          >
          <el-button class="tjsq" v-preventReClick @click="yybbtz(4)"
            >运输报备</el-button
          >
        </div> -->
        <div
          v-if="type == 'add' || type == 'edit' || type == 'fuzhi'"
          class="buttonList"
        >
<!--          <el-button class="zsbc" @click="ZSsave(1)">暂时保存</el-button>-->
          <el-button class="zsbc" @click="TempSave()">暂时保存</el-button>
          <el-button class="tjsq" @click="ZSsave(2)">提交申请</el-button>
        </div>
        <div v-if="type == 'query'" class="buttonList">
          <el-button class="tjsq" @click="ZSsave(4)">关闭</el-button>
        </div>
      </div>
      <div class="zjhx" style="font-size:14px;" v-if="formData.zt == '12' ||  formData.zt == '42' || formData.zt == '43'">
        <div style="padding: 20px 0 28px 0">
          <img src="../../assets/img/xkzsqtg.png" alt="">
        </div>
        <el-descriptions>
          <el-descriptions-item label="许可证编号">{{xkzBh}}</el-descriptions-item>
          <el-descriptions-item label="有效期限">{{yxqKs}} 至 {{yxqJs}}</el-descriptions-item>
          <el-descriptions-item label="状态">{{ztMc}}</el-descriptions-item>
        </el-descriptions>
      </div>
      <div class="zjhx" style="font-size:14px;" v-if="formData.hxsj != null && formData.hxsj != ''">
        <div style="padding: 20px 0 28px 0">
          <img src="../../assets/img/xkzhxxx.png" alt="">
        </div>
        <div style="margin-top: 2px">
          <span style="font-weight: bold">核销时间：</span><span>{{ formData.hxsj }}</span>
        </div>
        <div style="margin-top: 20px" v-if="formData.hxly != null && formData.hxly != ''">
          <span style="font-weight: bold">核销理由：</span><span>{{ formData.hxly }}</span>
        </div>
      </div>
      <div
        v-for="(name, index) in titlename"
        v-show="type == 'query'"
        :key="index"
      >
        <div v-if="dataobj[name.keyname].length > 0" class="zjhx">
          <div style="padding: 20px 0 28px 0">
            <img :src="name.ImageUrl" alt="">
          </div>
          <!-- <div
            style="
              border-left: 5px solid #be40e8;
              font-size: 18px;
              font-weight: 500;
              margin-bottom: 25px;
              padding-left: 10px;
            "
          >
            {{ name.ImageUrl }}
          </div> -->

          <el-timeline>
            <el-timeline-item
              v-if="dataobj[name.keyname][0]"
              icon="el-icon-time"
              size="large"
            >
              <div style="margin-top: 2px">
                <span style="font-weight: bold">申请时间：</span><span>{{ dataobj[name.keyname][0].clsj }}</span>
              </div>
            </el-timeline-item>
            <el-timeline-item
              v-for="(item, index) in dataobj[name.keyname]"
              :key="index"
              :icon="item.icon"
              :type="item.type"
              :size="item.size"
              :color="item.color"
            >
              <div
                style="
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                "
              >
                <div style="width: 40%">
                  <span style="font-weight: bold">审批单位：</span>{{ item.dqbmLabel }}
                </div>
                <div style="width: 17%">
                  <span style="font-weight: bold">{{ item.jsLabel }}人：</span>{{ item.sjsprLabel }}
                </div>
                <div style="width: 18%">
                  <span style="font-weight: bold">审批结果：</span><span
                    :style="
                      item.sftyLabel == '同意' ? 'color: #00ceb7' : 'color: red'
                    "
                  >{{ item.sftyLabel }}</span>
                </div>
                <div style="width: 25%">
                  <span style="font-weight: bold">审批时间：</span>{{ item.spsj }}
                </div>
              </div>
              <div style="margin-top: 2px">
                <span style="font-weight: bold">审批意见：</span><span>{{ item.spyj }}</span>
              </div>
              <div v-if="item.ywlx == 35" style="margin-top: 2px">
                <span style="font-weight: bold">取消核销理由：</span><span>{{ item.information }}</span>
              </div>
            </el-timeline-item>
          </el-timeline>
        </div>
      </div>

      <div v-if="type == 'xkzhx'" class="zjhx">
        <div class="title" style="margin-bottom: 28px">
          <img
            src="../../assets/img/xkzhxyy.png"
            alt=""
            style="width: 127px; height: 22px"
          >
        </div>
        <el-input
          v-model="hxly"
          :autosize="{ minRows: 4, maxRows: 6 }"
          type="textarea"
          placeholder="请填写核销原因"
        />
        <div class="buttonList">
          <el-button class="zsbc" @click="ZSsave(4)">取消</el-button>
          <el-button class="tjsq" @click="saveXkzHx()">确认</el-button>
        </div>
      </div>

      <div v-if="type == 'qxhx'" class="zjhx">
        <div class="title" style="margin-bottom: 28px">
          <img
            src="../../assets/img/gmsqzjhx.png"
            alt=""
            style="width: 127px; height: 22px"
          >
        </div>
        <el-input
          v-model="qxhxyy"
          :autosize="{ minRows: 4, maxRows: 6 }"
          type="textarea"
          placeholder="请填写取消核销原因"
        />
        <div class="buttonList">
          <el-button class="zsbc" @click="ZSsave(4)">取消</el-button>
          <el-button class="tjsq" @click="ZSsave(3)">确认</el-button>
        </div>
      </div>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title=""
      :visible.sync="dialogVisible"
      center
      @close="loading = true"
    >
      <div v-loading="loading" style="height: 350px">
        <div v-if="dialogType == 4" style="width: 100%; margin-bottom: 20px">
          许可证类型：
          <el-select v-model="searchCertType">
            <el-option value="G" label="购买证" />
            <el-option value="J" label="进口核查证" />
            <el-option value="D" label="药品证" />
            <el-option value="T" label="调剂证" />
          </el-select>
          许可证编号：
          <el-input
            v-model="gmzBhsearch"
            style="width: 250px; margin-right: 20px"
            clearable
          />
          <el-button
            v-preventReClick
            type="primary"
            style="background: #5377ff; border-color: #5377ff"
            @click="gmzBhSearch(1)"
          >搜索</el-button>
        </div>
        <div v-if="dialogType == 1 || dialogType == 2 || dialogType == 3" style="width: 100%; margin-bottom: 20px">
          单位名称：
          <el-input
            v-model="wldwSearch"
            style="width: 250px; margin-right: 20px"
            clearable
          />
          <el-button
            v-preventReClick
            type="primary"
            style="background: #5377ff; border-color: #5377ff"
            @click="danweiData(1)"
          >搜索</el-button>
        </div>
        <el-table
          ref="wldwtable"
          :data="tableData"
          border
          :show-overflow-tooltip="true"
          :header-cell-style="{ background: '#F2F2F2' }"
          style="width: 100%"
          highlight-current-row
          @select="selectChange"
        >
          <el-table-column
            align="center"
            type="selection"
            width="40"
          />
          <el-table-column
            v-for="(item, i) in tableTextType"
            :key="i"
            :show-overflow-tooltip="true"
            align="center"
            :label="item.label"
          >
            <template slot-scope="scope">
              <span :title="scope.row[item.key]">
                {{
                  item.key == "hzsl"
                    ? scope.row[item.key] + "(" + scope.row["hzslDwMc"] + ")"
                    : scope.row[item.key]
                }}
              </span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          layout="prev, pager,next,jumper,total"
          :total="total"
          :page-size="pagesize"
          class="el-page"
          :current-page.sync="currentPage"
          @current-change="handleCurrentChange"
        />
      </div>
      <div slot="footer">
        <el-button
          v-preventReClick
          @click="dialogVisible = false"
        >取 消</el-button>
        <el-button
          v-preventReClick
          type="primary"
          style="background: #5377ff; border-color: #5377ff"
          @click="wldwRow"
        >确 定</el-button>
      </div>
    </el-dialog>

    <yssq-dialog-inside
      ref="yssqdialoginside"
      :type="type"
      :gxhth="formData.gxhth"
    />
  </div>
</template>
<script>
import {
  getHxpCascader,
  applicationsNum,
  purchaseLicenseList,
  purchaseLicenseListByTjz,
  purchaseLicenseListByJkz,
  purchaseLicenseListByYpz,
  getjbr,
  ysdwlist,
  detail,
  getXzqTree,
  getXzqTreeS,
  addOrEditYSZ,
  xsdwgmdwMessage,
  xsdwgmdwMessageByTjz,
  xsdwgmdwMessageByJkz,
  xsdwgmdwMessageByYpz,
  qxhx,
  getdwforhxpBm,
  getgxhtMes,
  getCertificate, hexiao, addOrEditYSZTemp
} from '@/assets/js/yssq'
import { getkv, addgmzwldwMes, getsphjMes } from '@/assets/js/common.js'
import YssqDialogInside from './yssqDialogInside.vue'
import {
  validateNull,
  validateSljy,
  lengthValidate
} from '@/assets/js/validate.js'
import {isEmpty} from "@/utils/tool";
import {dealDataGy} from "@/utils/ppp";
export default {
  components: { YssqDialogInside },
  props: {
    type:{
      type: String
    },
    hxBeforeFlag:{
      type: Boolean
    }
  },
  data() {
    return {
      xzqhKey: 0,
      searchCertType: 'G',
      total: 0,
      pagesize: 5,
      currentPage: 1,
      loadingTow: false,
      loadingdialog: false,
      qsdQh: [],
      mddQh: [],
      options: [],

      loading: true,
      props: {
        // checkStrictly: true,
        lazy: true, // 开启懒加载
        lazyLoad(node, resolve) {
          const { level } = node
          setTimeout(() => {
            if (level == 0) {
              getXzqTree().then((res) => {
                const nodes = res.data.data.map((item) => ({
                  value: item.value,
                  label: item.label,
                  leaf: !item.leaf
                }))
                resolve(nodes)
              })
            } else {
              getXzqTreeS(node.value).then((res) => {
                const nodes = res.data.data.map((item) => ({
                  value: item.value,
                  label: item.label,
                  leaf: !item.leaf
                }))
                resolve(nodes)
              })
            }
          }, 300)
        }
      },
      gmzBhsearch: '',
      wldwSearch: '',
      huaxuepinList: [],
      yzd_nsjsl_dw: [],
      ysfsDataList: [],
      hxpBmDwList: [],
      ysfsList: [],
      xzqhList: [],
      xzqhFlag: true,
      jbrList: [],
      dialogType: '', // 打开的弹窗类型-1，2，3：往来单位列表弹窗，4购买证列表弹窗

      tableText: [
        {
          key: 'dwmc',
          label: '单位名称'
        },
        {
          key: 'shtyxydm',
          label: '统一社会信用代码'
        },
        {
          key: 'frmc',
          label: '单位法人/经营者'
        },
        {
          key: 'dwzj',
          label: '单位座机'
        },
        {
          key: 'dwdz',
          label: '单位地址'
        }
      ],

      tableText2: [
        {
          key: 'xkzBh',
          label: '许可证编号'
        },
        {
          key: 'hxpMc',
          label: '化学品名称'
        },
        {
          key: 'hzsl',
          label: '核准数量'
        },
        {
          key: 'ztMc',
          label: '状态'
        }
      ],
      // 列表数据
      tableData: [],
      dialogVisible: false,
      fhdwInputDisabled: true,
      shdwInputDisabled: true,
      ysdwInputDisabled: true,
      dynamicValidateForm: {
        domains: []
      },
      validateNullLog: {
        required: true,
        validator: validateNull,
        trigger: ['blur', 'change']
      },
      // 校验规则
      rules: {
        yssl: {
          validator: (rule, value, callback) => {
            if (
              /^[1-9]\d{0,8}(\.\d{1,3})?$|^0(\.\d{1,3})?$/.test(value) == false
            ) {
              callback(new Error('整数位最大长度9位,保留3位小数'))
            }
            callback()
          },
          trigger: ['blur', 'change']
        },
        beiz: [
          {
            validator: (rule, value, callback) => {
              lengthValidate(rule, value, callback, 'xt', 255)
            },
            trigger: ['blur', 'change']
          }
        ],
        ysfsDataList: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (this.ysfsDataList.length == 0) {
                callback(new Error('请选择运输方式'))
              }
              callback()
            },
            trigger: ['blur', 'change']
          }
        ],
        qsdQh: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (this.qsdQh.length == 0) {
                callback(new Error('请选择起始地'))
              }
              callback()
            },
            trigger: ['blur', 'change']
          }
        ],
        mddQh: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (this.mddQh.length == 0) {
                callback(new Error('请选择目的地'))
              }
              callback()
            },
            trigger: ['blur', 'change']
          }
        ],
        xzqhList: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (this.xzqhList.length == 0) {
                callback(new Error('请选择行政区划'))
              }
              callback()
            },
            trigger: ['blur', 'change']
          }
        ]
      },
      // 附件
      xgzlList: [],
      // 运输证类型
      yszlxList: [],
      gmxkzList: [],
      gmsl: '',
      sqsl: '',
      yssl: '',
      // 业务类型
      ywlxList: [
        {
          value: '1',
          label: '生产'
        },
        {
          value: '2',
          label: '使用'
        },
        {
          value: '3',
          label: '经营'
        },
        {
          value: '4',
          label: '运输'
        }
      ],
      hxly: '',
      qxhxyy: '',
      // 表单字段
      formData: {
        gxhth: '',
        id: '',
        yszType: '',
        gmzId: '',
        gmzBh: '',
        gmsl: '',
        gmsldw: '',
        gmsldwmc: '',
        ysqsl: '',
        ysqsldw: '',
        ysqsldwmc: '',
        bz: '',
        bzmc: '',
        hxpBm: '',
        hxpMc: '',
        yssl: '',
        ysslDw: '',
        ysfs: '',
        ysfsMc: '',
        hc: '',
        yxcs: '1',
        qsdQh: '',
        qsd: '',
        tjd: '',
        mddQh: '',
        mdd: '',
        jbrSfz: '',
        jbrXm: '',
        jbrSjhm: '',
        st: '',
        sj: '',
        qxj: '',
        pcs: '',
        beiz: '',
        ysdwId: '',
        ysdwMc: '',
        ysdwTyshxydm: '',
        ysdwYwlx: '',
        ysdwDwfr: '',
        ysdwDwzj: '',
        ysdwDwdz: '',
        zt: '',
        fhdwId: '',
        fhdwMc: '',
        fhdwTyshxydm: '',
        fhdwYwlx: '',
        fhdwDwfr: '',
        fhdwDwzj: '',
        fhdwDwdz: '',
        shdwId: '',
        shdwMc: '',
        shdwTyshxydm: '',
        shdwYwlx: '',
        shdwDwfr: '',
        shdwDwzj: '',
        shdwDwdz: '',
        gmzDfys1: '',
        gmzDfys2: '',
        gmzDfys3: '',
        gmzDfys4: '',
        gmzDfys5: '',
        province: '',
        city: '',
        county: '',
        hxsj:'',
        hxly:'',
        xkzYsFjxxList: []
      },
      bzList: [],
      fhdwywlxList: [], // 发货单位业务类型数组
      shdwywlxList: [], // 收获单位业务类型数组
      ysdwywlxList: [], // 运输单位业务类型数组
      wldwxx1: {},
      wldwxx2: {},
      wldwxx3: {},
      multipleSelection: [], // 多选选中数据
      zsid: '',
      yxcslist: ['1'],
      yxcsdisabled: true,
      flag1: false,
      xkzBh: '',
      yxqKs: '',
      yxqJs: '',
      ztMc: '',
      gxhthId: '',
      dataobj: {},
      titlename: []
    }
  },
  computed: {
    // 根据弹窗类型返回相应列表字段
    tableTextType() {
      if ([1, 2, 3].includes(this.dialogType)) {
        return this.tableText
      } else if (this.dialogType == 4) {
        return this.tableText2
      } else {
        return []
      }
    }
  },
  watch: {
    'formData.hxpBm': {
      deep: true,
      handler(newVal, oldVal) {
        if (newVal) {
          getdwforhxpBm(this.formData.hxpBm).then((e) => {
            this.hxpBmDwList = e.data.data
          })
        }
      }
    }
  },
  created() {
    // 获取化学品信息
    getHxpCascader().then((e) => {
      this.huaxuepinList = e.data.data
    })
    // 获取经办人
    getjbr().then((e) => {
      this.jbrList = e.data.data
    })
    // 获取单位
    getkv('yzd_nsjsl_dw').then((e) => {
      this.yzd_nsjsl_dw = e.data.data
    })
    // 获取运输方式
    getkv('yzd_ysfs').then((e) => {
      this.ysfsList = e.data.data
    })
    getkv('yzd_yszlx').then((e) => {
      this.yszlxList = e.data.data
    })
    getkv('yzd_bz').then((e) => {
      this.bzList = e.data.data
    })
    this.xgzlList = [
      {
        zjlx: 4, // 证件类型
        name: '经办人身份证', // 显示字段
        img: this.formData.xkzYsFjxxList
          .map((item) => parseInt(item.zjlx))
          .includes(4)
          ? require('../../assets/img/gmsqgmdw_down.png')
          : require('../../assets/img/gmsqgmdw.png'), // 默认图片
        pupopType: 'JBRdialogVisible', // 弹窗类型
        xianshi: " <span style='color: red;'>*</span> 经办人身份证"
      },
      {
        zjlx: 1,
        name: '营业执照',
        img: this.formData.xkzYsFjxxList
          .map((item) => parseInt(item.zjlx))
          .includes(1)
          ? require('../../assets/img/gmsqyyzz_down.png')
          : require('../../assets/img/gmsqyyzz.png'),
        pupopType: 'YYZZdialogVisible',
        xianshi: '营业执照'
      },
      {
        zjlx: 2,
        name: '其他组织的登记证书或者成立批准文件',
        img: this.formData.xkzYsFjxxList
          .map((item) => parseInt(item.zjlx))
          .includes(2)
          ? require('../../assets/img/gmsqdjzs_down.png')
          : require('../../assets/img/gmsqdjzs.png'),
        pupopType: 'QTZZdialogVisible',
        xianshi: '其他组织的登记证书或者成立<br/>批准文件'
      },
      {
        zjlx: 6,
        name: '购销合同',
        img: this.formData.xkzYsFjxxList
          .map((item) => parseInt(item.zjlx))
          .includes(6)
          ? require('../../assets/img/gmsqgxht_down.png')
          : require('../../assets/img/gmsqgxht.png'),
        pupopType: 'GXHTdialogVisible',
        xianshi: this.type == 'qxhx' || this.type == 'xkzhx' ? '购销合同' : " <span style='color: red;'>*</span> 购销合同"
      },
      {
        zjlx: 5,
        name: '货主身份证明',
        img: this.formData.xkzYsFjxxList
          .map((item) => parseInt(item.zjlx))
          .includes(5)
          ? require('../../assets/img/gmsqgmdw_down.png')
          : require('../../assets/img/gmsqgmdw.png'), // 默认图片
        pupopType: 'SFZMdialogVisible',
        xianshi: '货主身份证明'
      },
      {
        zjlx: 7,
        name: '其他证件',
        img: this.formData.xkzYsFjxxList
          .map((item) => parseInt(item.zjlx))
          .includes(7)
          ? require('../../assets/img/step45.png')
          : require('../../assets/img/step45_down.png'),
        pupopType: 'QTdialogVisible',
        xianshi: '其他证件'
      }
    ]
  },
  mounted() {
    if (this.type == 'add') {
      this.getCertificateMes() // 营业执照信息
    }
    if(this.hxBeforeFlag){
      this.hxly = '证书已百分百使用完成'
    }else{
      this.hxly = ''
    }
  },
  methods: {
    lengthValidate,
    validateSljy,
    validateNull,
    // 购销合同改变时
    gxhthImage(val) {
      this.xgzlList.filter((item, index) => {
        if (item.zjlx == 6) {
          this.xgzlList.splice(index, 1)
        }
      })
      var flag1 = this.formData.xkzYsFjxxList.some((item, index, arr) => {
        return item.zjlx == '6'
      })

      flag1 == true
        ? this.formData.xkzYsFjxxList.filter((item, index, arr) => {
          if (item.zjlx == '6') {
            this.formData.xkzYsFjxxList.splice(index, 1)
          }
        })
        : ''
      this.imgChange()
    },
    // 营业执照信息
    async getCertificateMes() {
      var ret = await getCertificate()
      if (ret.data.data.zjlx == '2') {
        ret.data.data.qtzzZsmc = ret.data.data.yyzzMc
        ret.data.data.qtzzZsbh = ret.data.data.yyzzTyshxydm
        this.formData.xkzYsFjxxList[2] = ret.data.data
      } else this.formData.xkzYsFjxxList[1] = ret.data.data
      this.imgChange() // 营业执照带出信息后图片改变
    },
    imgChange() {
      this.xgzlList = [
        {
          zjlx: 4, // 证件类型
          name: '经办人身份证', // 显示字段
          img: this.formData.xkzYsFjxxList
            .map((item) => parseInt(item.zjlx))
            .includes(4)
            ? require('../../assets/img/gmsqgmdw_down.png')
            : require('../../assets/img/gmsqgmdw.png'), // 默认图片
          pupopType: 'JBRdialogVisible', // 弹窗类型
          xianshi: " <span style='color: red;'>*</span> 经办人身份证"
        },
        {
          zjlx: 1,
          name: '营业执照',
          img: this.formData.xkzYsFjxxList
            .map((item) => parseInt(item.zjlx))
            .includes(1)
            ? require('../../assets/img/gmsqyyzz_down.png')
            : require('../../assets/img/gmsqyyzz.png'),
          pupopType: 'YYZZdialogVisible',
          xianshi: '营业执照'
        },
        {
          zjlx: 2,
          name: '其他组织的登记证书或者成立批准文件',
          img: this.formData.xkzYsFjxxList
            .map((item) => parseInt(item.zjlx))
            .includes(2)
            ? require('../../assets/img/gmsqdjzs_down.png')
            : require('../../assets/img/gmsqdjzs.png'),
          pupopType: 'QTZZdialogVisible',
          xianshi: '其他组织的登记证书或者成立<br/>批准文件'
        },
        {
          zjlx: 6,
          name: '购销合同',
          img: this.formData.xkzYsFjxxList
            .map((item) => parseInt(item.zjlx))
            .includes(6)
            ? require('../../assets/img/gmsqgxht_down.png')
            : require('../../assets/img/gmsqgxht.png'),
          pupopType: 'GXHTdialogVisible',
          xianshi: this.type == 'qxhx' || this.type == 'xkzhx' ? '购销合同' : " <span style='color: red;'>*</span> 购销合同"
        },
        {
          zjlx: 5,
          name: '货主身份证明',
          img: this.formData.xkzYsFjxxList
            .map((item) => parseInt(item.zjlx))
            .includes(5)
            ? require('../../assets/img/gmsqgmdw_down.png')
            : require('../../assets/img/gmsqgmdw.png'), // 默认图片
          pupopType: 'SFZMdialogVisible',
          xianshi: '货主身份证明'
        },
        {
          zjlx: 7,
          name: '其他证件',
          img: this.formData.xkzYsFjxxList
            .map((item) => parseInt(item.zjlx))
            .includes(7)
            ? require('../../assets/img/step45.png')
            : require('../../assets/img/step45_down.png'),
          pupopType: 'QTdialogVisible',
          xianshi: '其他证件'
        }
      ]
      // 移库运输没有购销合同号
      if (this.formData.yszType == 2) {
        this.xgzlList.filter((item, index) => {
          if (item.zjlx == 6) {
            this.xgzlList.splice(index, 1)
          }
          return this.xgzlList
        })

        var flag1 = this.formData.xkzYsFjxxList.some((item, index, arr) => {
          return item.zjlx == '6'
        })

        flag1 == true
          ? this.formData.xkzYsFjxxList.filter((item, index, arr) => {
            if (item.zjlx == '6') {
              this.formData.xkzYsFjxxList.splice(index, 1)
            }
          })
          : ''
      }
      if (this.formData.hxpBm) {
        if (this.formData.hxpBm.slice(0, 1) == '1') {
          this.yxcsdisabled = true
          this.formData.yxcs = '1'
          this.yxcslist = ['1']
        } else {
          this.yxcsdisabled = false
        }
      }
    },
    yxcschange(value) {
      if (value.slice(-1) != '') {
        this.yxcslist = []
        this.formData.yxcs = value.slice(-1).toString()
        this.yxcslist.push(value.slice(-1).toString())
      } else this.yxcslist.push(this.formData.yxcs)
    },
    // 运输方式改变
    yszTypechange(val) {
      // this.$refs.jbxxForm.resetFields();
      this.$refs.fhdwForm.resetFields()
      this.$refs.shdwForm.resetFields()
      this.$refs.ysdwForm.resetFields()
      this.formData.hxpBm = ''
      this.formData.hxpMc = ''
      this.formData.gxhth = ''
      this.formData.gmzDfys1 = ''
      this.formData.gmzDfys2 = ''
      this.formData.gmzDfys3 = ''
      this.formData.gmzDfys4 = ''
      this.formData.gmzDfys5 = ''
      this.dynamicValidateForm.domains = []
      this.formData.yszType = val
      if (val == '2') {
        this.formData.gmzId = ''
        this.formData.gmzBh = ''
        this.formData.gmsl = ''
        this.formData.gmsldwmc = ''
        this.formData.gmsldw = ''
        this.formData.ysqsl = ''
        this.formData.ysqsldw = ''
        this.formData.ysqsldwmc = ''
      }
      if (val == '3') {
        this.formData.ysqsl = ''
        this.formData.ysqsldw = ''
        this.formData.ysqsldwmc = ''
      }
      if (this.formData.gmzBh && val != '2') this.gmzTableData()
      this.imgChange()
    },
    async xsdwgmdwMessages(data) {
      this.formData.xkzYsFjxxList[5] = {}
      this.imgChange()
      let API = xsdwgmdwMessage
      const gmzBh = data.gmzBh
      if (this.searchCertType === 'J') {
        API = xsdwgmdwMessageByJkz
        delete data.gmzBh
        data.jkhczBh = gmzBh
      } else if (this.searchCertType === 'D') {
        API = xsdwgmdwMessageByYpz
        delete data.gmzBh
        data.ypzBh = gmzBh
      } else if (this.searchCertType === 'T') {
        API = xsdwgmdwMessageByTjz
        delete data.gmzBh
        data.tjzBh = gmzBh
      }
      var e = await API(data)
      if (e.data.code == '000000') {
        this.formData.fhdwId = e.data.data.fhdwId
        this.formData.fhdwMc = e.data.data.fhdwMc
        this.formData.fhdwTyshxydm = e.data.data.fhdwTyshxydm
        this.formData.fhdwDwfr = e.data.data.fhdwDwfr
        this.formData.fhdwDwzj = e.data.data.fhdwDwzj
        this.formData.fhdwDwdz = e.data.data.fhdwDwdz
        this.formData.shdwId = e.data.data.shdwId
        this.formData.shdwMc = e.data.data.shdwMc
        this.formData.shdwTyshxydm = e.data.data.shdwTyshxydm
        this.formData.shdwDwfr = e.data.data.shdwDwfr
        this.formData.shdwDwzj = e.data.data.shdwDwzj
        this.formData.shdwDwdz = e.data.data.shdwDwdz
        this.formData.gmsl = e.data.data.gmsl
        this.formData.gmsldwmc = e.data.data.gmsldwmc
        this.formData.gmsldw = e.data.data.gmsldw
        this.formData.hxpBm = e.data.data.hxpBm
        this.formData.hxpMc = e.data.data.hxpMc
        this.formData.gxhth = e.data.data.gxhth
        this.formData.gmzId = e.data.data.gmzId
      }
      this.yxcsdisabled = this.formData.hxpBm.slice(0, 1) == '1'
      this.yxcslist =
        this.formData.yxcs != ''
          ? this.formData.yxcs.split(',')
          : this.formData.hxpBm.slice(0, 1) == '1'
            ? ['1']
            : ['2']
      getgxhtMes(this.searchCertType, this.formData.gmzBh).then((e) => {
        var flag1 = this.formData.xkzYsFjxxList.some((item, index, arr) => {
          return item.zjlx == '6'
        })
        flag1 == true
          ? this.formData.xkzYsFjxxList.filter((item, index) => {
            if (item.zjlx == '6') {
              this.formData.xkzYsFjxxList.splice(index, 1)
            }
          })
          : ''
        this.formData.xkzYsFjxxList[5] = e.data.data
        this.imgChange()
      })
    },
    // 当前页变化时
    handleCurrentChange(val) {
      this.currentPage = val // 当前页
      if (this.dialogType == 4) {
        // 4打开的是购买证列表
        this.gmzBhSearch()
      } else {
        // 1，2，3打开的是往来单位列表
        this.danweiData() // 获取往来单位数据
      }
    },
    // 实现table单选
    selectChange(selection, row) {
      this.$refs.wldwtable.clearSelection()
      if (selection.length === 0) {
        return
      }
      if (row) {
        this.$refs.wldwtable.toggleRowSelection(row, true)
      }
    },
    // 购买证编号列表弹窗和往来单位弹窗确定时
    wldwRow() {
      const data = this.$refs.wldwtable.selection[0] // 获取勾选的一行数据
      // 如果勾选了数据
      if (data) {
        // 判断打开的弹窗是什么
        switch (this.dialogType) {
          case 1: // 如果是发货单位给发货单位相应的form字段赋值
            this.wldwxx1 = data
            // this.fhdwInputDisabled = true; //不可更改
            this.formData.fhdwId = data.dwId
            this.formData.fhdwMc = data.dwmc
            this.formData.fhdwTyshxydm = data.shtyxydm
            // this.fhdwywlxList = data.ywlx.split(",");
            this.formData.fhdwYwlx = data.ywlx
            this.formData.fhdwDwfr = data.frmc
            this.formData.fhdwDwzj = data.dwzj
            this.formData.fhdwDwdz = data.dwdz
            if (this.formData.yszType == 2) {
              this.formData.shdwId = data.dwId
              this.formData.shdwMc = data.dwmc
              this.formData.shdwTyshxydm = data.shtyxydm
              // this.shdwywlxList = data.ywlx.split(",");
              this.formData.shdwYwlx = data.ywlx
              this.formData.shdwDwfr = data.frmc
              this.formData.shdwDwzj = data.dwzj
              this.formData.shdwDwdz = data.dwdz
            }
            this.dialogVisible = false // 关闭弹窗
            break
          case 2: // 如果是收获单位
            this.wldwxx2 = data
            // this.shdwInputDisabled = true;
            this.formData.shdwId = data.dwId
            this.formData.shdwMc = data.dwmc
            this.formData.shdwTyshxydm = data.shtyxydm
            // this.shdwywlxList = data.ywlx.split(",");
            this.formData.shdwYwlx = data.ywlx
            this.formData.shdwDwfr = data.frmc
            this.formData.shdwDwzj = data.dwzj
            this.formData.shdwDwdz = data.dwdz
            this.dialogVisible = false
            break
          case 3: // 如果是运输单位
            this.wldwxx3 = data
            // this.ysdwInputDisabled = true;
            this.formData.ysdwId = data.dwId
            this.formData.ysdwMc = data.dwmc
            this.formData.ysdwTyshxydm = data.shtyxydm
            // this.ysdwywlxList = data.ywlx.split(",");
            this.formData.ysdwYwlx = data.ywlx
            this.formData.ysdwDwfr = data.frmc
            this.formData.ysdwDwzj = data.dwzj
            this.formData.ysdwDwdz = data.dwdz
            this.dialogVisible = false
            break
          case 4: // 如果是购买证列表
            // this.formData.gmzId = data.id;
            this.formData.gmzBh = data.xkzBh
            // this.formData.gxhth = data.gxhth;
            this.formData.ysslDw = ''

            this.xsdwgmdwMessages({
              yszType: this.formData.yszType,
              gmzBh: this.formData.gmzBh
            })
            if(this.formData.yszType != '2'){ //移库运输不查询购买证信息
              applicationsNum(this.searchCertType, this.formData.gmzBh).then((e) => {
                this.formData.ysqsl = e.data.data.ysqsl
                this.formData.ysqsldw = e.data.data.ysqsldw
                this.formData.ysqsldwmc = e.data.data.ysqsldwmc
              })
            }
            this.dialogVisible = false
            break
          default:
            break
        }
      } else {
        this.dialogVisible = false
      }
    },
    // 获取购买证编号列表
    async gmzTableData() {
      if (this.formData.gmzBh && this.formData.yszType) {
        this.formData.ysqsl = ''
        this.formData.ysqsldw = ''
        this.formData.ysqsldwmc = ''
        this.formData.gmsl = ''
        this.formData.gmsldwmc = ''
        this.formData.gmsldw = ''
        this.formData.hxpBm = ''
        this.formData.hxpMc = ''
        this.formData.ysslDw = ''
        this.formData.gxhth = ''
        this.formData.gmzId = ''
        this.xsdwgmdwMessages({
          yszType: this.formData.yszType,
          gmzBh: this.formData.gmzBh
        })
        var e = await applicationsNum(this.searchCertType, this.formData.gmzBh)
        if (e.data.code == '000000') {
          this.formData.ysqsl = e.data.data.ysqsl
          this.formData.ysqsldw = e.data.data.ysqsldw
          this.formData.ysqsldwmc = e.data.data.ysqsldwmc
        }
      }
    },
    // 化学品级联改变
    handleChange(value) {
      if (value == undefined) return
      this.formData.hxpBm = value.slice(-1).toString()
      this.formData.hxpMc = this.$refs.hxps.getCheckedNodes()[0].data.label
      this.formData.ysslDw = ''
      if (this.formData.hxpBm) {
        if (this.formData.hxpBm.slice(0, 1) == '1') {
          this.yxcsdisabled = true
        } else {
          this.yxcsdisabled = false
        }
      }
    },
    // 关闭页面
    back() {
      this.$parent.pupopShow = false
    },
    // 包装改变时
    bzchange(val) {
      this.bzList.forEach((item) => {
        if (item.value == val) this.formData.bzmc = item.label
      })
    },
    addGxhtInputChange(val, index) { },
    // 打开往来单位弹窗
    danweixuanze(e) {
      this.wldwSearch = ''
      this.dialogVisible = true
      this.dialogType = e
      this.currentPage = 1
      this.danweiData()
    },
    // 获取往来单位列表
    danweiData(curpage) {
      if(curpage == 1){
        this.currentPage = curpage
      }
      ysdwlist({
        page: this.currentPage,
        size: 5,
        param: {
          dwmc: this.wldwSearch
        }
      }).then((e) => {
        this.loading = false
        this.tableData = e.data.data.rows
        this.total = e.data.data.total
      })
    },
    // 打开购买证编号列表弹窗
    gmzTableShow() {
      this.gmzBhsearch = ''
      this.dialogType = 4
      this.dialogVisible = true
      this.currentPage = 1
      this.gmzBhSearch()
    },
    gmzBhSearch(curpage) {
      if(curpage == 1){
        this.currentPage = curpage
      }
      const params = {
        yszType: this.formData.yszType,
        beginTime: '',
        endTime: '',
        xkzBh: this.gmzBhsearch
      }
      let API = purchaseLicenseList
      if (this.searchCertType === 'J') {
        API = purchaseLicenseListByJkz
        // params.jkhczBh = this.gmzBhsearch
      } else if (this.searchCertType === 'D') {
        API = purchaseLicenseListByYpz
        // params.ypzBh = this.gmzBhsearch
      } else if (this.searchCertType === 'T') {
        API = purchaseLicenseListByTjz
        // params.tjzBh = this.gmzBhsearch
      } else {
        // params.xkzBh = this.gmzBhsearch
      }
      API({
        page: this.currentPage,
        size: 5,
        param: params
      }).then((e) => {
        this.loading = false
        this.tableData = e.data.data.rows
        this.total = e.data.data.total
      })
    },

    // 行政区划级联变化时触发
    qhChange(value, type) {
      if (type == 'qsd') {
        this.xzqhFlag = false
        this.xzqhList = JSON.parse(JSON.stringify(value))
        this.xzqhKey ++ //让级联数据可以回显
        this.formData.province = this.xzqhList[0] || ''
        this.formData.city = this.xzqhList[1] || ''
        this.formData.county = this.xzqhList[2] || ''
        setTimeout(() => {
          this.xzqhFlag = true
        }, 0)
        this.$refs.refHandlexzqh.handleExpandChange(this.xzqhList)
        this.formData.qsdQh = value.join(',') // 起始地
        this.formData.qsd = this.$refs.refHandleqsd
          .getCheckedNodes(true)[0]
          .pathLabels.join(',')
        this.$refs.jbxxForm.clearValidate(['xzqhList'])
      } else if (type == 'mdd') {
        this.formData.mddQh = value.join(',')
        this.formData.mdd = this.$refs.refHandlemdd
          .getCheckedNodes(true)[0]
          .pathLabels.join(',')
      } else {
        this.formData.province = this.xzqhList[0] || ''
        this.formData.city = this.xzqhList[1] || ''
        this.formData.county = this.xzqhList[2] || ''
      }
    },
    // 运输方式数据变化时触发
    ysfsChange(value) {
      this.formData.ysfs = value.join(',')
      this.formData.ysfsMc = []
      this.ysfsList.forEach((item) => {
        if (value.includes(item.value)) this.formData.ysfsMc.push(item.label)
      })
      this.formData.ysfsMc = this.formData.ysfsMc.join(',')
      this.ysfsList.length == this.formData.ysfs.split(',').length
        ? this.$refs.ysfsxianshi.blur()
        : ''
    },

    dwmcBlur(event) { },
    // 点击上传附件图片
    async imageClick(typeVal, zjlx) {
      this.$refs.yssqdialoginside[typeVal] = true
      // 根据证件类型传入不同的数据
      var arr = this.formData.xkzYsFjxxList.filter((item, index, arr) => {
        return item.zjlx == zjlx
      })
      if (!arr[0]) {
        arr[0] = {}
        arr[0].zjlx = zjlx
        arr[0].fjList = []
      }
      // console.log(...this.formData.xkzYsFjxxList);
      // console.log(arr[0])
      if(zjlx == '6' && !(this.type == 'query' || this.type == 'qxhx' || this.type == 'xkzhx')){
        //购销合同可以赋初始值：化学品、合同编号
        if(isEmpty(arr[0].gxhtHxp) && !isEmpty(this.formData.hxpBm)){
          arr[0].gxhtHxp = this.formData.hxpBm
        }
        if(isEmpty(arr[0].gxhtHtbh) && !isEmpty(this.formData.gxhth)){
          arr[0].gxhtHtbh = this.formData.gxhth
        }
      }
      this.$refs.yssqdialoginside.FileDataShow(arr[0])
    },
    // 手动追加的购买证input输入框数据
    gmzDfysList() {
      const data = this.dynamicValidateForm.domains
      this.formData.gmzDfys1 = ''
      this.formData.gmzDfys2 = ''
      this.formData.gmzDfys3 = ''
      this.formData.gmzDfys4 = ''
      this.formData.gmzDfys5 = ''
      // 循环往form表单里添加数据
      for (let i = 0; i < data.length; i++) {
        var name = 'gmzDfys' + (i + 1)
        this.formData[name] = data[i].value
      }
    },
    //核销保存
    saveXkzHx(){
      if (!this.hxly && this.type == 'xkzhx') {
        this.$message.error('请填写核销原因')
        return false
      }
      this.$confirm('是否确认核销?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          hexiao({id:this.formData.id,hxly:this.hxly}).then((e) => {
            this.loadingdialog = false
            this.$message.success('核销成功')
            this.$parent.getTableData()
          })
            .catch(() => {
              this.loadingdialog = false
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })

    },
    //暂时保存，不需要任何校验
    TempSave(){
      this.gmzDfysList()
      this.formData.xkzYsFjxxList = this.formData.xkzYsFjxxList.filter(obj => Object.keys(obj).length !== 0)
      // 用 filter 一次性保留有效附件，避免 forEach 中 splice 导致后续元素被跳过
      this.formData.xkzYsFjxxList = this.formData.xkzYsFjxxList.filter((item) => {
        if (item.zjlx == '6') {
          item.id = item.id ? item.id : this.gxhthId
        }
        return !!(item.zjlx && item.fjList && item.fjList.length > 0)
      })
      this.formData.zt = '00' // 状态00为草稿
      // 如果不是查看数据时
      this.$confirm('是否暂时保存为草稿?', '提示', {
        confirmButtonText: '确定',
        confirmButtonClass: 'quedingActive',
        cancelButtonText: '取消',
        showClose: false,
        center: true,
        customClass: 'dwmcBlur_class'
      }).then(async() => {
        this.loadingdialog = true
          // 调用接口添加
        try {
          // 许可证类型
          this.formData.zslx = this.searchCertType
          this.formData.vdata = await dealDataGy()
          var ret = await addOrEditYSZTemp(this.formData)
          this.loadingdialog = false
          this.$parent.getTableData()
        } catch (error) {
          this.loadingdialog = false
        }
      })
    },
    // 保存
    ZSsave(type) {
      if (this.type == 'query' || type == 4) {
        this.$parent.pupopShow = false
        return
      }
      if (type != 3) { //3 是取消核销
        this.gmzDfysList()
        // 四个表单验证
        if(type != 1){ //暂时保存不需要验证
          let [prop1, prop2, prop3, prop4] = [false, false, false, false]

          this.$refs.jbxxForm.validate((valid) => {
            prop1 = valid
          })
          this.$refs.fhdwForm.validate((valid) => {
            prop2 = valid
          })
          this.$refs.shdwForm.validate((valid) => {
            prop3 = valid
          })
          this.$refs.ysdwForm.validate((valid) => {
            prop4 = valid
          })
          if (!prop1 || !prop2 || !prop3 || !prop4) {
            setTimeout(() => {
              var isError = document.getElementsByClassName('is-error')
              isError[0].querySelector('input').focus()
            }, 100)
            return false
          }

        }

        // this.$refs.yssqdialoginside.RemoveImgById(); //调用子组件中删除附件方法
        // 将form表单中附件数据数组空对象剔除
        this.formData.xkzYsFjxxList = this.formData.xkzYsFjxxList.filter(obj => Object.keys(obj).length !== 0)
        // 许可证必传
        var zjlxs = []
        var mes = []
        if (this.formData.xkzYsFjxxList.length > 0) {
          this.formData.xkzYsFjxxList.forEach((item, index) => {
            item.zjlx && item.fjList.length > 0
              ? zjlxs.push(parseInt(item.zjlx))
              : this.formData.xkzYsFjxxList.splice(index, 1)
            if (item.zjlx == '6') {
              item.id = item.id ? item.id : this.gxhthId
            }
          })
        }
        if (zjlxs.includes(4)) {
        } else mes.push('经办人身份证')
        if (this.xgzlList.map((item) => item.zjlx).includes(6)) {
          // 如果包含购销合同数据
          if (zjlxs.includes(6) || (this.type == 'qxhx' && type == 3)) { // 取消核销不校验购销合同必填
          } else {
            mes.push('购销合同')
          }
        }

        if (type != 1 && mes.length > 0) {
          this.$message({
            type: 'error',
            message: '请补全' + mes.toString() + '信息'
          })
          return false
        }

      }else if (!this.qxhxyy && this.type == 'qxhx' && type == 3){
        this.$message.error('请填写取消核销原因')
        return false
      }

      let text
      switch (type) {
        case 1:
          this.formData.zt = '00' // 状态00为草稿
          text = '是否暂时保存为草稿?'
          break
        case 2:
          this.formData.zt = '11' // 状态11为提交
          text = '是否提交申请?'
          break
        case 3:
          text = '确认取消核销?'
          break
        case 4:
          this.$parent.pupopShow = false // 查看数据时，点击按钮直接关闭页面
          break
        default:
          break
      }

      // 如果不是查看数据时
      this.$confirm(text, '提示', {
        confirmButtonText: '确定',
        confirmButtonClass: 'quedingActive',
        cancelButtonText: '取消',
        showClose: false,
        center: true,
        customClass: 'dwmcBlur_class'
      }).then(async() => {
        this.loadingdialog = true
        // 核销
        if (this.type == 'qxhx') {
          qxhx({
            id: this.formData.id,
            sqdwZj: this.formData.sqdwZj,
            zt: '42',
            qxhxly: this.qxhxyy
          })
            .then((e) => {
              this.loadingdialog = false
              this.$message.success('取消核销成功')
              // this.$parent.pupopShow = false; //成功后关闭页面
              this.$parent.getTableData()
            })
            .catch(() => {
              this.loadingdialog = false
            })
        } else {
          // 调用接口添加

          try {
            // 许可证类型
            this.formData.zslx = this.searchCertType
            this.formData.vdata = await dealDataGy()
            if(type == 1){ //暂时保存
              var ret = await addOrEditYSZTemp(this.formData)
            }else{
              var ret = await addOrEditYSZ(this.formData)
            }
            this.loadingdialog = false
            this.$parent.getTableData()
          } catch (error) {
            this.loadingdialog = false
          }

          // if (
          //   !this.fhdwInputDisabled ||
          //   !this.shdwInputDisabled ||
          //   !this.ysdwInputDisabled
          // ) {
          //   this.reset();
          // } else {
          // this.$parent.pupopShow = false; //成功后关闭页面

          // }
        }
      })
    },
    async reset() {
      return new Promise(async(resolve, reject) => {
        if (!this.fhdwInputDisabled) {
          this.$confirm('是否要将该单位加入发货单位？', '提示', {
            confirmButtonText: '确定',
            confirmButtonClass: 'quedingActive',
            cancelButtonText: '取消',
            showClose: false,
            center: true,
            customClass: 'dwmcBlur_class'
          })
            .then(async() => {
              resolve(123)
              // 添加往来单位信息
              return await addgmzwldwMes({
                id: '', // 没有值为新增，有值为修改
                dwId: '',
                glrwdwId: this.wldwxx1.glrwdwId,
                dwmc: this.formData.fhdwMc,
                shtyxydm: this.formData.fhdwTyshxydm,
                dwdz: this.formData.fhdwDwdz,
                frmc: this.formData.fhdwDwfr,
                dwzj: this.formData.fhdwDwzj,
                dwsj: this.wldwxx1.dwsj,
                dwxz: this.wldwxx1.dwxz,
                dwlx: this.wldwxx1.dwlx
              })
            })
            .catch(() => {
              resolve(123)
            })
        } else {
          resolve(123)
        }
      })
        .then(() => {
          return new Promise((resolve, reject) => {
            if (!this.shdwInputDisabled) {
              this.$confirm('是否要将该单位加入收货单位？', '提示', {
                confirmButtonText: '确定',
                confirmButtonClass: 'quedingActive',
                cancelButtonText: '取消',
                showClose: false,
                center: true,
                customClass: 'dwmcBlur_class'
              })
                .then(async() => {
                  resolve()
                  // 添加往来单位信息
                  return await addgmzwldwMes({
                    id: '', // 没有值为新增，有值为修改
                    dwId: '',
                    glrwdwId: this.wldwxx2.glrwdwId,
                    dwmc: this.formData.shdwMc,
                    shtyxydm: this.formData.shdwTyshxydm,
                    dwdz: this.formData.shdwDwdz,
                    frmc: this.formData.shdwDwfr,
                    dwzj: this.formData.shdwDwzj,
                    dwsj: this.wldwxx2.dwsj,
                    dwxz: this.wldwxx2.dwxz,
                    dwlx: this.wldwxx2.dwlx
                  })
                })
                .catch(() => {
                  resolve(123)
                })
            } else {
              resolve(123)
            }
          })
        })
        .then(() => {
          return new Promise((resolve, reject) => {
            if (!this.ysdwInputDisabled) {
              this.$confirm('是否要将该单位加入运输单位？', '提示', {
                confirmButtonText: '确定',
                confirmButtonClass: 'quedingActive',
                cancelButtonText: '取消',
                showClose: false,
                center: true,
                customClass: 'dwmcBlur_class'
              })
                .then(async() => {
                  resolve(123)
                  // 添加往来单位信息
                  return await addgmzwldwMes({
                    id: '', // 没有值为新增，有值为修改
                    dwId: '',
                    glrwdwId: this.wldwxx3.glrwdwId,
                    dwmc: this.formData.ysdwMc,
                    shtyxydm: this.formData.ysdwTyshxydm,
                    dwdz: this.formData.ysdwDwdz,
                    frmc: this.formData.ysdwDwfr,
                    dwzj: this.formData.ysdwDwzj,
                    dwsj: this.wldwxx3.dwsj,
                    dwxz: this.wldwxx3.dwxz,
                    dwlx: this.wldwxx3.dwlx
                  })
                })
                .catch(() => {
                  resolve(123)
                })
            } else {
              resolve(123)
            }
          })
        })
        .then(() => {
          // this.$parent.pupopShow = false; //成功后关闭页面
          this.$parent.getTableData()
        })
    },
    yybbtz() {
      this.$router.push({
        name: 'Ysbb',
        params: { xkzBh: this.formData.xkzBh }
      })
    },

    // 手动追加购买证输入框
    addDomain() {
      // if (this.type == "query") return;
      // this.dynamicValidateForm.domains.forEach((item) => {
      //   item.imgurl = require("../../assets/img/delete.png");
      //   item.leixing = "delete";
      // });
      // if (this.dynamicValidateForm.domains.length < 4) {
      //   this.dynamicValidateForm.domains.push({
      //     value: "",
      //     imgurl: require("../../assets/img/push.png"),
      //     leixing: "push",
      //   });
      // } else if (this.dynamicValidateForm.domains.length == 4) {
      //   this.dynamicValidateForm.domains.push({
      //     value: "",
      //     imgurl: require("../../assets/img/delete.png"),
      //     leixing: "delete",
      //   });
      // }
      if (this.type == 'query') return
      if (this.dynamicValidateForm.domains.length < 4) {
        this.dynamicValidateForm.domains.push({
          value: ''
        })
      } else {
        this.$message({
          message: '购买证编号不可超过5个！',
          type: 'warning'
        })
      }
    },
    // 删除追加的购买证输入框
    removeDomain(item, index) {
      // var index = this.dynamicValidateForm.domains.indexOf(item);
      // if (index !== -1) {
      //   this.dynamicValidateForm.domains.splice(index, 1);
      // }
      // var zhyg = this.dynamicValidateForm.domains.filter((item, index) => {
      //   return index == this.dynamicValidateForm.domains.length - 1;
      // });
      // zhyg[0].imgurl = require("../../assets/img/push.png");
      // zhyg[0].leixing = "push";
      var index = this.dynamicValidateForm.domains.indexOf(item)

      if (index !== -1) {
        this.dynamicValidateForm.domains.splice(index, 1)
      }
    },
    // 选择经办人数据发生变化时
    jbrChange(val) {
      var id = ''
      if (this.formData.xkzYsFjxxList[0]) { id = this.formData.xkzYsFjxxList[0].id }

      this.formData.jbrXm = val.xm
      this.formData.jbrSjhm = val.sjhm
      this.formData.jbrSfz = val.zjhm
      this.formData.fjList = [{ wjdz: val.zjzpZm, zjlx: '4', id: '' }]
      this.formData.xkzYsFjxxList[0] = {
        id: id,
        zjlx: '4',
        jbrXm: this.formData.jbrXm,
        jbrSjh: this.formData.jbrSjhm,
        jbrSfzh: this.formData.jbrSfz,
        fjList: this.formData.fjList
      }
      this.imgChange()
    },
    // 根据id查询运输证详情信息
    queryByID(id) {
      this.loadingTow = true // 骨架屏
      // 重新加载前先清空，避免残留上一张运输证的审批时间线和行政区划
      this.titlename = []
      this.xzqhList = []
      if (this.type == 'query') {
        getsphjMes('Y', id).then((e) => {
          const dataobj = e.data.data
          for (var key of Object.keys(dataobj)) {
            dataobj[key].forEach((hj, index) => {
              if (key == 'zssq') {
                if (index == 0) {
                  this.titlename.push({
                    keyname: key,
                    ImageUrl: require('@/assets/img/bgsp/crksqsp.png')
                  })
                }
                if (
                  index == dataobj.zssq.length - 1 ||
                  dataobj.zssq.length == 1
                ) {
                  hj.icon = 'el-icon-success'
                  hj.size = 'large'
                }
              } else {
                dataobj[key + index] = []
                hj.forEach((qxhxhj, index1) => {
                  if (index1 == hj.length - 1 || hj.length == 1) {
                    qxhxhj.icon = 'el-icon-success'
                    qxhxhj.size = 'large'
                  }
                  if (index1 == 0) {
                    this.titlename.push({
                      keyname: key + index,
                      ImageUrl: require('@/assets/img/bgsp/qxhxsp.png')
                    })
                  }
                  dataobj[key + index].push(qxhxhj)
                })
              }
            })
          }
          delete dataobj.zsqxhx
          this.dataobj = dataobj
        })
      }
      detail(id).then((e) => {
        const data = e.data.data
        this.searchCertType = data.zslx || 'G'
        // 如果是复制新增，清空所有id，有id是修改
        if (this.type == 'fuzhi') {
          data.xkzBh = ''
          data.zt = ''
          data.hxsj = ''
          if(data.yszType != '2' && !isEmpty(data.gmzBh)){ //移库运输不查询购买证信息
            applicationsNum(this.searchCertType, data.gmzBh).then((e) => {
              data.ysqsl = e.data.data.ysqsl
              data.ysqsldw = e.data.data.ysqsldw
              data.ysqsldwmc = e.data.data.ysqsldwmc
            })
          }
          data.id = '' // 清空id
          data.xkzYsFjxxList.filter((e, index) => {
            e.id = '' // 清空附件数组id
            e.fjList.filter((e, index) => {
              e.id = '' // 清空附件id
            })
            return data.xkzYsFjxxList
          })
        }else{
          this.yxqKs = data.yxqKs
          this.yxqJs = data.yxqJs
          this.ztMc = data.ztMc
        }

        this.formData = data // 表单赋值
        this.xkzBh = this.formData.xkzBh
        this.yxcsdisabled =
          this.formData.hxpBm.slice(0, 1) == '1'
        this.formData.yxcs =
          this.type == 'query' || this.type == 'qxhx' || this.type == 'xkzhx' ? data.hzcs : data.yxcs // 有效次数
        this.formData.gmsl =
          this.type == 'query' || this.type == 'qxhx' || this.type == 'xkzhx' ? data.hzsl : data.gmsl //
        this.formData.gmsldw =
          this.type == 'query' || this.type == 'qxhx' || this.type == 'xkzhx'
            ? data.hzslDw
            : data.gmsldw
        this.yxcslist =
          this.formData.yxcs != ''
            ? this.formData.yxcs.split(',')
            : this.formData.hxpBm.slice(0, 1) == '1'
              ? ['1']
              : ['2']
        if(data.ysfs){
          this.ysfsDataList = data.ysfs.split(',') // 运输方式绑定
        }
        this.$nextTick(() => {
          if(data.qsdQh){
            this.qsdQh = data.qsdQh.split(',').map(Number) // 起始地赋值
          }
          if(data.mddQh){
            this.mddQh = data.mddQh.split(',').map(Number) // 目的地赋值
          }
          // 公安机关赋值
          if(data.province){
            this.xzqhList.push(data.province)
          }
          if(data.city){
            this.xzqhList.push(data.city)
          }
          if(data.county){
            this.xzqhList.push(data.county)
          }
          // if (data.town) this.xzqhList.push(data.town);

          // this.fhdwywlxList = data.fhdwYwlx.split(","); //发货单位业务类型
          // this.shdwywlxList = data.shdwYwlx.split(","); //收货单位业务类型
          // this.ysdwywlxList = data.ysdwYwlx.split(","); //运输单位业务类型
        })
        // 将多出的购买证号追加到数组
        const addGmzList = []
        addGmzList.push(data.gmzDfys1)
        addGmzList.push(data.gmzDfys2)
        addGmzList.push(data.gmzDfys3)
        addGmzList.push(data.gmzDfys4)
        addGmzList.push(data.gmzDfys5)
        // 重新加载详情前先清空，避免残留上一个运输证的购买证输入框
        this.dynamicValidateForm.domains = []
        // 遍历数组往手动追加购买证输入框绑定数组赋值
        addGmzList.forEach((e) => {
          if (e) {
            this.dynamicValidateForm.domains.push({
              value: e
              // imgurl: require("../../assets/img/delete.png"),
            })
          }
          // this.dynamicValidateForm.domains[
          //   this.dynamicValidateForm.domains.length - 1
          // ].imgurl = require("../../assets/img/push.png");
        })
        var xkzYsFjxxList = this.formData.xkzYsFjxxList
        this.formData.xkzYsFjxxList = []
        xkzYsFjxxList.forEach((item) => {
          item.zjlx == '4'
            ? (this.formData.xkzYsFjxxList[0] = item)
            : item.zjlx == '1'
              ? (this.formData.xkzYsFjxxList[1] = item)
              : item.zjlx == '2'
                ? (this.formData.xkzYsFjxxList[2] = item)
                : item.zjlx == '6'
                  ? (this.formData.xkzYsFjxxList[5] = item)
                  : item.zjlx == '5'
                    ? (this.formData.xkzYsFjxxList[3] = item)
                    : item.zjlx == '7'
                      ? (this.formData.xkzYsFjxxList[4] = item)
                      : {}
        })
        if (this.formData.xkzYsFjxxList[5] && this.formData.xkzYsFjxxList[5].id) { this.gxhthId = this.formData.xkzYsFjxxList[5].id }

        this.imgChange()
        this.loadingTow = false // 关闭骨架屏
        this.$nextTick(()=>{
          this.$refs.jbxxForm.clearValidate() //清楚页面所有校验结果
          this.$refs.fhdwForm.clearValidate() //清楚页面所有校验结果
          this.$refs.shdwForm.clearValidate() //清楚页面所有校验结果
          this.$refs.ysdwForm.clearValidate() //清楚页面所有校验结果
        })
      })
    }
  }
}
</script>
<style lang="less" scoped>
/deep/.el-radio__input.is-checked .el-radio__inner {
  border-color: none;
  background: url("../../assets/img/radiobox_down.png");
  background-size: 100% 100%;
}
/deep/.el-radio__input .el-radio__inner {
  border-color: none;
  background: url("../../assets/img/radiobox.png");
  background-size: 100% 100%;
  border-radius: 0;
  border: none;
}
/deep/.el-radio__input.is-checked .el-radio__inner::after {
  content: "";
  background: none;
}
// .el-cascader-panel .el-radio {
//   width: 100%;
//   height: 100%;
//   z-index: 10;
//   position: absolute;
//   // top: 0px;
//   right: 0px;
// }

// .el-cascader-panel .el-cascader-node__postfix {
//   top: 10px;
// }

.yssq_process {
  width: 90%;
  max-width: 1200px;
  margin: auto;
  .process_form {
    padding-top: 10px;
    .title {
      margin-bottom: 40px;
      // margin-top: 40px;
    }
    .el-form {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      .el-switch {
        height: 39px;
      }
    }
    .jbxx {
      background-color: white;
      padding-left: 118px;
      padding-right: 118px;
      /* margin-top: 40px; */
      padding-top: 40px;
      margin-bottom: 15px;

      p {
        margin-left: 110px;
        margin-top: 0;
        width: 247px;
        height: 18px;
        font-size: 13px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #636363;
        line-height: 18px;
      }
    }
    .fhdw,
    .shdw,
    .ysdw,
    .xgzl,
    .zjhx {
      background-color: white;
      padding-left: 118px;
      padding-right: 118px;
      /* margin-top: 40px; */
      padding-top: 40px;
      margin-bottom: 15px;
      padding-bottom: 40px;
      p {
        margin: 0;
        font-size: 14px;
        margin-left: 100px;
        margin-bottom: 20px;
        color: rgb(83, 119, 255);
      }
    }

    .xgzl {
      padding-bottom: 40px;
      .el-icon-warning-outline {
        color: #ff7e31;
      }
      .el-icon-warning-outline:before {
        content: "\e6c9";
        font-size: 15px;
        font-weight: bold;
      }
      .tishi {
        display: flex;
        img {
          margin-top: 1px;
          width: 15px;
          height: 15px;
          margin-right: 5px;
          vertical-align: middle;
        }
        p {
          display: inline-block;
        }
      }
      p {
        // display: inline-block;
        margin-bottom: 31px;
        margin-left: 0;
        height: 18px;
        font-size: 13px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #636363;
        line-height: 18px;
      }

      // .xgzlsc::after {
      //   content: "";
      //   width: 202px;
      // }
    }
    .buttonList {
      padding-top: 50px;
      padding-bottom: 50px;
      display: flex;
      justify-content: space-evenly;

      .zsbc {
        color: #333333;
        width: 148px;
        height: 60px;
        background: #ebebeb;
        border-radius: 5px;
        border: none;
      }
      .tjsq {
        color: #ffffff;
        width: 148px;
        height: 60px;
        background: #4170ff;
        border-radius: 5px;
        border: none;
      }
    }
    .xuanze {
      margin-left: 5px;
      color: #ffffff;
      width: 65px;
      height: 39px;
      background: #5377ff;
      border-radius: 2px;
    }
  }
  .el-form {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .el-form-item {
      margin-right: 0;
      width: 45%;
      /deep/.el-form-item__content {
        display: flex !important;
      }
    }
  }
}
/deep/ .has-gutter {
  .el-checkbox {
    display: none;
  }
}
/deep/.xgzlsc {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  & > div {
    margin-bottom: 40px;
  }
  p {
    margin: auto;
    text-align: center;
    span {
      color: #f56c6c;
      margin-right: 4px;
    }
  }
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #4170ff !important;
  color: #fff;
}
/deep/.el-page {
  // width: 90px;
  // height: 39px;
  border: 1px solid #ebeef5 !important;
  border-top: none !important;
  .el-pager {
    .active {
      background: #4170ff;
      border-radius: 3px;
      border-color: #4170ff;
    }
  }
}
/deep/input::-webkit-outer-spin-button,
/deep/input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
/deep/input[type="number"] {
  -moz-appearance: textfield;
}
/deep/.el-timeline {
  padding-left: 0;
}
/deep/.el-timeline-item__icon {
  font-size: 16px !important;
  color: #fff;
  background-color: #ef9a12;
  border-radius: 50%;
}

/deep/.el-icon-success {
  color: #6acd18;
  background-color: #fff;
}
</style>
